import { checkIsAuthorized } from "components/helpers";
import useAuthStore from "stores/useAuthStore";

const useAuthorized = (permissions, params) => {
  const userAuth = useAuthStore(s => s.userAuth);
  const permissionCategories = useAuthStore(s => s.permissionCategories);

  return checkIsAuthorized(permissions, {
    ...params,
    userAuth,
    permissionCategories,
  });
};

export default useAuthorized;
